import { createTypes } from 'redux-action-types'
import api from '../api'

export const types = createTypes('fridge/types/',
  'SAVE',
  'DELETE'
)

export const save = async (data, id = null, dataType = 'type', redirect = false) => {
  const endpoint = dataType === 'type' ? 'types' : 'roles'

  const type = id
    ? await api.put(`${endpoint}/${id}`, data)
    : await api.post(endpoint, data)

  return {
    type: types.SAVE,
    data: {[dataType]: type, dataType},
    redirect: redirect ? `${redirect}/${type.slug}` : false
  }
}

export const remove = async (data, dataType = 'type') => {
  const endpoint = dataType === 'type' ? 'types' : 'roles'

  await api.delete(`${endpoint}/${data.id}`)

  return {
    type: types.DELETE,
    data: {[dataType]: data, dataType}
  }
}



// WEBPACK FOOTER //
// ./app/actions/types.js